<template>
	<TopNavFooter>
  <div class="main-content" id="admin" style="">
  <spinner :spinnerOn="loading"></spinner>
    <div class="container-fluid" style="background: #fff;padding: 0px;padding-top:35px;">
      <div class="container">
	  <div style="margin:-15px">
	  <div class="bc-adduser">
      <div style="font-size: 44px !important;font-weight: bold;overflow: auto;margin-bottom: 15px;"><span>{{user_lang.myprofile}}</span>
	  <div style="float: right;margin-top: -5px;"
	  v-if="(reverseTransformedEmail.toLowerCase().indexOf('cargill.') == -1 && reverseTransformedEmail.toLowerCase().indexOf('crgl-thirdparty.') == -1 && reverseTransformedEmail.toLowerCase().indexOf('awb.') == -1)">
					<button type="button" class="btn btn-primary adduser-btn" v-on:click="editFields()"
					v-show = "!enableEdit && (!isAzureUser || isServiceAccountGroupMember)"
					v-bind:class = "{disabled: isAzureUser && !isServiceAccountGroupMember}"> {{user_lang.edit}}</button>
		</div>
	  </div>
    <div class="usercreateinfo" id="resetpasswordsuccess" v-show="nameUpdated">
		  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "nameUpdated = false"></i></div>
		  <div style="display: inline-block;margin: 0px 10px;"><i class="fa fa-check-circle" style=" font-size:50px "></i></div>
		  <div style="display: inline-block;font-size: 14px;font-weight: bold;vertical-align: super;">{{user_lang.nameUpdated}}
		  </div>
		</div>
	  <div class="usercreateinfo" id="resetpasswordsuccess" v-show="pwdupdated">
		  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "pwdupdated = false"></i></div>
		  <div style="display: inline-block;margin: 0px 10px;"><i class="fa fa-check-circle" style=" font-size:50px "></i></div>
		  <div style="display: inline-block;font-size: 14px;font-weight: bold;vertical-align: super;">{{user_lang.pwdupdated}}
		  </div>
		  </div>
	  <div class="usercreateinfo" id="resetpasswordsuccess" v-show="QAupdated">
		  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "QAupdated = false"></i></div>
		  <div style="display: inline-block;margin: 0px 10px;"><i class="fa fa-check-circle" style=" font-size:50px "></i></div>
		  <div style="display: inline-block;font-size: 14px;font-weight: bold;vertical-align: super;">{{user_lang.QAupdated}}
		  </div>
		  </div>
	  <div class="usercreateinfo" id="resetpasswordsuccess" v-show="phoneupdated">
		  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "phoneupdated = false"></i></div>
		  <div style="display: inline-block;margin: 0px 10px;"><i class="fa fa-check-circle" style=" font-size:50px "></i></div>
		  <div style="display: inline-block;font-size: 14px;font-weight: bold;vertical-align: super;">{{user_lang.phoneupdated}}
		  </div>
	  </div>
	  <div class="usercreateinfo" id="resetpasswordsuccess" v-show="activationpending">
		  <div><i class="fa fa-close" style="float: right;cursor:pointer" @click = "activationpending = false"></i></div>
		  <div style="display: inline-block;margin: 0px 10px;"><i class="fa fa-check-circle" style=" font-size:50px "></i></div>
		  <div style="display: inline-block;font-size: 14px;font-weight: bold;vertical-align: super;">{{user_lang.activationpending}}
		  </div>
	  </div>
	  </div>
      <div class="card-block" style="background:#f1f1f1 !important; margin-bottom: 10px;    padding: 14px 14px;">
	  <div class="user-creds">
	   <label class="form-control-label">{{user_lang.basicinfo}}:</label>
	  <div class="row" style="padding-bottom: 15px;">
	  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
	  <div class="form-wrap">
          <span for="message-text" class="form-control-label">{{user_lang.first_name}}:</span>
          <span class="wrap-input">
            <input class="form-control input-adduser" v-bind:class = "{disabled : !enableEdit}" id="message-text" v-model="firstname" :tabindex="-1"></input></span>
		  </div>
	  </div>
	  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
	  <div class="form-wrap">
          <span for="message-text" class="form-control-label">{{user_lang.last_name}}:</span>
          <span class="wrap-input"><input class="form-control input-adduser" v-bind:class = "{disabled : !enableEdit}" id="message-text" v-model="lastname" :tabindex="-1"></input></span>
		  </div>
	  </div>
	  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
		  <div class="form-wrap">
          <span for="message-text" class="form-control-label">{{user_lang.primary_mail}}:</span>
          <span class="wrap-input"><input class="form-control input-adduser disabled" id="message-text" v-model="reverseTransformedEmail" :tabindex="-1"></input></span>
		  </div>
	  </div>
    <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
		  <div class="form-wrap">
          <span for="message-text" class="form-control-label">{{user_lang.secondary_mail}}:</span>
          <span class="wrap-input"><input class="form-control input-adduser" v-bind:class = "{disabled : !enableEdit}" id="message-text" v-model="addUserSecondaryEmail" :tabindex="-1"></input></span>
		  </div>
	  </div>
	  </div>
	   <div class="row">
	  <div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12" v-show = "enableEdit" style="padding-bottom: 15px;">
	  <label class="form-control-label" style="min-width: initial;">{{user_lang.changepwd}}:</label>
       <i class="fa fa-edit" style="cursor:pointer" @click = "passwordsec = !passwordsec"></i>
		<div v-show = "passwordsec">
      <div class="row">
	      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="text-align: left;">
		  <span class="form-control-label">{{user_lang.oldpwd}}</span>
           <input type="password" v-model="oldpassword" placeholder="******" class="form-control input-adduser"
		   v-bind:class = "{disabled : !enableEdit}" style="width:100%;"></input>
          </div>
		  </div>
		  <div class="row" v-show = "oldpassword.trim().length > 0">
          <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="text-align: left;">
		  <span class="form-control-label">{{user_lang.enter_new_pwd}}</span>
           <input type="password" v-model="password" placeholder="******" class="form-control input-adduser"
		   v-bind:class = "{disabled : !enableEdit}" style="width:100%;"></input>
		   <!--span class="password-rule">{{user_lang.pwd_rule}}</span-->
          </div>
		  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="text-align: left;">
		  <span class="form-control-label">{{user_lang.repeat_pwd}}</span>
           <input type="password" v-model="repeatpassword" placeholder="******" class="form-control input-adduser"
		   v-bind:class = "{disabled : !enableEdit}" style="width:100%;"></input>
          </div>
		  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="text-align: left;">
		  <span style="color:transparent;width:100%;display: block;" class="sometext-hidden">sometext</span>
		  <button type="button" class="btn btn-primary adduser-btn" style="margin-left: 0px;max-height: 34px;" v-on:click="updatePwd()" v-show="enableEdit"
		  v-bind:class = "{disabled : repeatpassword.length === 0 || password.length === 0 || oldpassword.length === 0 }"> {{user_lang.update}}</button></div>
		</div>
		<div class="row">
		<div class="col-lg-8 col-md-8 col-sm-12 col-xs-12" style="text-align: left;">
		<span class="pwderror" v-for="i in pwdValidationObj">{{i}}</span>
	  <span class="pwderror" v-for="j in repeatPwdValidationObj">{{j}}</span>
	  </div>
	   </div>
	  <span class="error" v-for="k in formValidationObj" v-show = "enableEdit">{{k}}</span>
	  </div>
	  </div>
	  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" v-show = "enableEdit" style="padding-bottom: 15px;">
		  <div>
          <label for="message-text" class="form-control-label" style="min-width: initial;">{{user_lang.nop}}:</label>
       <i class="fa fa-edit" style="cursor:pointer" @click = "phnsec = !phnsec"></i>
	  <div v-show = "phnsec">
      <div class="row">
		 <div class="wrap-input col-lg-4 col-md-4 col-sm-6 col-xs-12 donotedit" v-show="!codeSent && !factorDeleted" style="margin-bottom: 5px;">
		  <input class="form-control input-adduser disabled donotedit" :tabindex="-1" id="message-text" v-model="phone" style="display: inline-block;"></input>
          </div>
		  <div class="wrap-input col-lg-4 col-md-4 col-sm-6 col-xs-12" v-show="!codeSent && !factorDeleted">
		  <button type="button" class="btn btn-primary adduser-btn"
		  style="margin-left:0px !important;" v-on:click="updatePhone()" v-show = "enableEdit"> {{user_lang.update}}</button>
		  <span style="font-size:12px; padding-left:10px">{{factorStatus}}</span>
          </div>
		  </div>
		  </div>
		   </div>
	  <div v-show = "phnsec">
		  <div class="row" v-show="factorDeleted && !codeSent && enableEdit">
				<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="display: inline-block;float: left;">
				<div>
    <span for="countryCode">{{user_lang.country}}</span>
	<span class="fa fa-info-circle"  v-bind:title = "user_lang.country_inst" data-toggle="tooltip"
	data-placement="right" style="padding-left: 5px;"></span>
</div>
<div class="clearfix">
<select id="countryCode" name="countryCode" v-model="countryCode" style="width:100%;padding: 0px 10px !important;">
 <option value="93">{{user_lang['93']}}</option> <!-- refer locale file -->
<option value="355">{{user_lang['355']}}</option>
<option value="213">{{user_lang['213']}}</option>
<option value="1684">{{user_lang['1684']}}</option>
<option value="376">{{user_lang['376']}}</option>
<option value="244">{{user_lang['244']}}</option>
<option value="1264">{{user_lang['1264']}}</option>
<option value="0672">{{user_lang['antar']}}</option>
<option value="1268">{{user_lang['1268']}}</option>
<option value="54">{{user_lang['54']}}</option>
<option value="374">{{user_lang['374']}}</option>
<option value="297">{{user_lang['297']}}</option>
<option value="061">{{user_lang['aus']}}</option>
<option value="43">{{user_lang['43']}}</option>
<option value="994">{{user_lang['994']}}</option>
<option value="1242">{{user_lang['1242']}}</option>
<option value="973">{{user_lang['973']}}</option>
<option value="880">{{user_lang['880']}}</option>
<option value="1246">{{user_lang['1246']}}</option>
<option value="375">{{user_lang['375']}}</option>
<option value="32">{{user_lang['32']}}</option>
<option value="501">{{user_lang['501']}}</option>
<option value="229">{{user_lang['229']}}</option>
<option value="1441">{{user_lang['1441']}}</option>
<option value="975">{{user_lang['975']}}</option>
<option value="591">{{user_lang['591']}}</option>
<option value="387">{{user_lang['387']}}</option>
<option value="267">{{user_lang['267']}}</option>
<option value="55">{{user_lang['55']}}</option>
<option value="246">{{user_lang['246']}}</option>
<option value="673">{{user_lang['673']}}</option>
<option value="359">{{user_lang['359']}}</option>
<option value="226">{{user_lang['226']}}</option>
<option value="257">{{user_lang['257']}}</option>
<option value="855">{{user_lang['855']}}</option>
<option value="237">{{user_lang['237']}}</option>
<option value="01">{{user_lang['can']}}</option>
<option value="238">{{user_lang['238']}}</option>
<option value="1345">{{user_lang['1345']}}</option>
<option value="236">{{user_lang['236']}}</option>
<option value="235">{{user_lang['235']}}</option>
<option value="56">{{user_lang['56']}}</option>
<option value="86">{{user_lang['86']}}</option>
<option value="61">{{user_lang['61']}}</option>
<option value="57">{{user_lang['57']}}</option>
<option value="269">{{user_lang['269']}}</option>
<option value="242">{{user_lang['242']}}</option>
<option value="243">{{user_lang['243']}}</option>
<option value="682">{{user_lang['682']}}</option>
<option value="506">{{user_lang['506']}}</option>
<option value="385">{{user_lang['385']}}</option>
<option value="53">{{user_lang['53']}}</option>
<option value="357">{{user_lang['357']}}</option>
<option value="420">{{user_lang['420']}}</option>
<option value="45">{{user_lang['45']}}</option>
<option value="253">{{user_lang['253']}}</option>
<option value="1767">{{user_lang['1767']}}</option>
<option value="1809">{{user_lang['1809']}}</option>
<option value="593">{{user_lang['593']}}</option>
<option value="20">{{user_lang['20']}}</option>
<option value="503">{{user_lang['503']}}</option>
<option value="240">{{user_lang['240']}}</option>
<option value="291">{{user_lang['291']}}</option>
<option value="372">{{user_lang['372']}}</option>
<option value="251">{{user_lang['251']}}</option>
<option value="0500">{{user_lang['falk']}}</option>
<option value="298">{{user_lang['298']}}</option>
<option value="679">{{user_lang['679']}}</option>
<option value="358">{{user_lang['358']}}</option>
<option value="33">{{user_lang['33']}}</option>
<option value="689">{{user_lang['689']}}</option>
<option value="241">{{user_lang['241']}}</option>
<option value="220">{{user_lang['220']}}</option>
<option value="995">{{user_lang['995']}}</option>
<option value="49">{{user_lang['49']}}</option>
<option value="233">{{user_lang['233']}}</option>
<option value="350">{{user_lang['350']}}</option>
<option value="30">{{user_lang['30']}}</option>
<option value="299">{{user_lang['299']}}</option>
<option value="1473">{{user_lang['1473']}}</option>
<option value="590">{{user_lang['590']}}</option>
<option value="1671">{{user_lang['1671']}}</option>
<option value="502">{{user_lang['502']}}</option>
<option value="441481">{{user_lang['441481']}}</option>
<option value="224">{{user_lang['224']}}</option>
<option value="245">{{user_lang['245']}}</option>
<option value="592">{{user_lang['592']}}</option>
<option value="509">{{user_lang['509']}}</option>
<option value="379">{{user_lang['379']}}</option>
<option value="504">{{user_lang['504']}}</option>
<option value="852">{{user_lang['852']}}</option>
<option value="36">{{user_lang['36']}}</option>
<option value="354">{{user_lang['354']}}</option>
<option value="91">{{user_lang['91']}}</option>
<option value="62">{{user_lang['62']}}</option>
<option value="98">{{user_lang['98']}}</option>
<option value="964">{{user_lang['964']}}</option>
<option value="353">{{user_lang['353']}}</option>
<option value="972">{{user_lang['972']}}</option>
<option value="39">{{user_lang['39']}}</option>
<option value="225">{{user_lang['225']}}</option>
<option value="1876">{{user_lang['1876']}}</option>
<option value="81">{{user_lang['81']}}</option>
<option value="441534">{{user_lang['441534']}}</option>
<option value="962">{{user_lang['962']}}</option>
<option value="07">{{user_lang['kazak']}}</option>
<option value="254">{{user_lang['254']}}</option>
<option value="686">{{user_lang['686']}}</option>
<option value="850">{{user_lang['850']}}</option>
<option value="82">{{user_lang['82']}}</option>
<option value="965">{{user_lang['965']}}</option>
<option value="996">{{user_lang['996']}}</option>
<option value="856">{{user_lang['856']}}</option>
<option value="371">{{user_lang['371']}}</option>
<option value="961">{{user_lang['961']}}</option>
<option value="266">{{user_lang['266']}}</option>
<option value="231">{{user_lang['231']}}</option>
<option value="218">{{user_lang['218']}}</option>
<option value="423">{{user_lang['423']}}</option>
<option value="370">{{user_lang['370']}}</option>
<option value="352">{{user_lang['352']}}</option>
<option value="853">{{user_lang['853']}}</option>
<option value="389">{{user_lang['389']}}</option>
<option value="261">{{user_lang['261']}}</option>
<option value="265">{{user_lang['265']}}</option>
<option value="60">{{user_lang['60']}}</option>
<option value="960">{{user_lang['960']}}</option>
<option value="223">{{user_lang['223']}}</option>
<option value="356">{{user_lang['356']}}</option>
<option value="692">{{user_lang['692']}}</option>
<option value="596">{{user_lang['596']}}</option>
<option value="222">{{user_lang['222']}}</option>
<option value="230">{{user_lang['230']}}</option>
<option value="0262">{{user_lang['mayotte']}}</option>
<option value="52">{{user_lang['52']}}</option>
<option value="691">{{user_lang['691']}}</option>
<option value="373">{{user_lang['373']}}</option>
<option value="377">{{user_lang['377']}}</option>
<option value="976">{{user_lang['976']}}</option>
<option value="382">{{user_lang['382']}}</option>
<option value="1664">{{user_lang['1664']}}</option>
<option value="0212">{{user_lang['morocco']}}</option>
<option value="258">{{user_lang['258']}}</option>
<option value="95">{{user_lang['95']}}</option>
<option value="264">{{user_lang['264']}}</option>
<option value="674">{{user_lang['674']}}</option>
<option value="977">{{user_lang['977']}}</option>
<option value="31">{{user_lang['31']}}</option>
<option value="599">{{user_lang['599']}}</option>
<option value="687">{{user_lang['687']}}</option>
<option value="64">{{user_lang['64']}}</option>
<option value="505">{{user_lang['505']}}</option>
<option value="227">{{user_lang['227']}}</option>
<option value="234">{{user_lang['234']}}</option>
<option value="683">{{user_lang['683']}}</option>
<option value="672">{{user_lang['672']}}</option>
<option value="1670">{{user_lang['1670']}}</option>
<option value="047">{{user_lang['norway']}}</option>
<option value="968">{{user_lang['968']}}</option>
<option value="92">{{user_lang['92']}}</option>
<option value="680">{{user_lang['680']}}</option>
<option value="970">{{user_lang['970']}}</option>
<option value="507">{{user_lang['507']}}</option>
<option value="675">{{user_lang['675']}}</option>
<option value="595">{{user_lang['595']}}</option>
<option value="51">{{user_lang['51']}}</option>
<option value="63">{{user_lang['63']}}</option>
<option value="064">{{user_lang['pitcairn']}}</option>
<option value="48">{{user_lang['48']}}</option>
<option value="351">{{user_lang['351']}}</option>
<option value="1787">{{user_lang['1787']}}</option>
<option value="974">{{user_lang['974']}}</option>
<option value="262">{{user_lang['262']}}</option>
<option value="40">{{user_lang['40']}}</option>
<option value="7">{{user_lang['7']}}</option>
<option value="250">{{user_lang['250']}}</option>
<option value="290">{{user_lang['290']}}</option>
<option value="1869">{{user_lang['1869']}}</option>
<option value="1758">{{user_lang['1758']}}</option>
<option value="508">{{user_lang['508']}}</option>
<option value="1784">{{user_lang['1784']}}</option>
<option value="685">{{user_lang['685']}}</option>
<option value="378">{{user_lang['378']}}</option>
<option value="239">{{user_lang['239']}}</option>
<option value="966">{{user_lang['966']}}</option>
<option value="221">{{user_lang['221']}}</option>
<option value="381">{{user_lang['381']}}</option>
<option value="248">{{user_lang['248']}}</option>
<option value="232">{{user_lang['232']}}</option>
<option value="65">{{user_lang['65']}}</option>
<option value="421">{{user_lang['421']}}</option>
<option value="386">{{user_lang['386']}}</option>
<option value="677">{{user_lang['677']}}</option>
<option value="252">{{user_lang['252']}}</option>
<option value="27">{{user_lang['27']}}</option>
<option value="500">{{user_lang['500']}}</option>
<option value="211">{{user_lang['211']}}</option>
<option value="34">{{user_lang['34']}}</option>
<option value="94">{{user_lang['94']}}</option>
<option value="249">{{user_lang['249']}}</option>
<option value="597">{{user_lang['597']}}</option>
<option value="47">{{user_lang['47']}}</option>
<option value="268">{{user_lang['268']}}</option>
<option value="46">{{user_lang['46']}}</option>
<option value="41">{{user_lang['41']}}</option>
<option value="963">{{user_lang['963']}}</option>
<option value="886">{{user_lang['886']}}</option>
<option value="992">{{user_lang['992']}}</option>
<option value="255">{{user_lang['255']}}</option>
<option value="66">{{user_lang['66']}}</option>
<option value="670">{{user_lang['670']}}</option>
<option value="228">{{user_lang['228']}}</option>
<option value="690">{{user_lang['690']}}</option>
<option value="676">{{user_lang['676']}}</option>
<option value="1868">{{user_lang['1868']}}</option>
<option value="216">{{user_lang['216']}}</option>
<option value="90">{{user_lang['90']}}</option>
<option value="993">{{user_lang['993']}}</option>
<option value="1649">{{user_lang['1649']}}</option>
<option value="688">{{user_lang['688']}}</option>
<option value="256">{{user_lang['256']}}</option>
<option value="380">{{user_lang['380']}}</option>
<option value="971">{{user_lang['971']}}</option>
<option value="44">{{user_lang['44']}}</option>
<option value="1" selected="">{{user_lang['1']}}</option>
<option value="598">{{user_lang['598']}}</option>
<option value="998">{{user_lang['998']}}</option>
<option value="678">{{user_lang['678']}}</option>
<option value="58">{{user_lang['58']}}</option>
<option value="84">{{user_lang['84']}}</option>
<option value="1284">{{user_lang['1284']}}</option>
<option value="1340">{{user_lang['1340']}}</option>
<option value="681">{{user_lang['681']}}</option>
<option value="212">{{user_lang['212']}}</option>
<option value="967">{{user_lang['967']}}</option>
<option value="260">{{user_lang['260']}}</option>
<option value="263">{{user_lang['263']}}</option>
    </select>
</div>
</div>
<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
<div style="">
    <span for="phN">{{user_lang.nop}}</span>
	<span class="fa fa-info-circle"  v-bind:title = "user_lang.nop_inst"
	data-toggle="tooltip" data-placement="right" style="padding-left: 5px;"></span>
</div>
<div class="clearfix">
    <input type="text" id="pn" v-model="phN" style="width: 100%;-webkit-user-select: auto !important;" autocomplete="false">
	<!-- readonly @focus = "onf($event)" @blur= "onb($event)" onfocus = "this.removeAttribute('readonly')" -->
</div>
</div>
<div style="" class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
<span style="color: transparent; width: 100%; display: block;" class="sometext-hidden">sometext</span>
          <button v-show="!codeSent" v-bind:class="{disabled: !phN.trim().length}"
		  style="padding: 14px 23px;background:#f9f9f9;color:#595959;border:1px solid #c3c3c3;font-size:12px;height: 30px;margin-left:0px !important"
		  class="btn btn-primary adduser-btn" @click="sendCode()">{{user_lang.update}}</button>
		  <!--button  v-show="codeSent" type="button" class="btn btn-default"
		  style="background:#f9f9f9;color:#595959;border:1px solid #c3c3c3;font-size:13px;"
		  @click = "showPhNoPane = false">{{user_lang.done}}</button-->
</div>
<div class="error" v-show = "error30SecOTP == true">
<!--div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
<span class="exclamatory-error-icon">!</span></div-->{{user_lang.OTPEnableAfter30Sec}}</div>
<div class="error" v-show = "phoneNumberNotValid == true">
<!--div style="background:#e34843;width:22px; height:auto;display: inline-block;margin-right: 10px;">
<span class="exclamatory-error-icon">!</span></div-->{{user_lang.phonenumberinvalid}}</div>
</div>
		  <div style="color:#a7a7a7;margin-top: 5px;" v-show="codeSent">{{user_lang.enter_code_rule}}</div>
		<div v-show="codeSent" id="smsPhoneCodeForm.edit.form" class="m-form verify-code-form clearfix leave-open-on-success"
		style="padding: 0px 15px; margin: 0px -15px;">
            <input type="hidden" class="hide" name="_xsrfToken" value="bd39219af46c391c0ea3df7053f999588ed2ca5a8553eaf83a32d4d3f063915f">
			<input type="hidden" name="smsFactor" value="true">
            <input name="activateFactor" value="false" type="hidden" class="hide">
            <label id="smsPhoneCodeForm.code.label" for="verifyCode" class="margin-btm-0" path="token" csserrorclass="error" style="display: block;">{{user_lang.enter_code}}
			</label>
			<input v-model="verifycode" id="verifyCode" name="code" class="verify-code" type="text" value="" autocomplete="off"
			style="visibility: inherit;position: inherit;max-width:200px !important;display: inline-block !important;display: inline-block !important;
                                                padding-top: 14px;">
			<button  v-show="codeSent" class="codeVerifybtn" v-bind:class = "{disabled : verifycode.trim().length === 0}" @click="verifySMS()">{{user_lang.verify}}</button>
			<button  v-show="codeSent" class="codeVerifybtn" @click="goBack()">{{user_lang.back}}</button>
			<div id="smsPhoneCodeForm.edit.errors" style="" class="" v-show="passCodeInvalid">
               <div style="padding:10px 0px;" class="error">{{user_lang.passcodeNotValid}}</div>
            </div>
			<div style="padding:10px 0px;" class="error" v-show = "error30SecOTP == true">{{user_lang.OTPEnableAfter30Sec}}</div>
			<div style="padding:10px 0px;" class="error" v-show = "emptypasscode == true">{{user_lang.emptypasscode}}</div>
        </div>
	  <span class="error" v-for="j in phoneValidationObj" v-show = "enableEdit">{{j}}</span>
	  </div>
	  </div>
    <!-- Commented for Security Question Removal -->
	  <!--div class="setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12" v-show = "enableEdit" style="padding-bottom: 15px;">
	  <div class="row" style="padding-top: 0px">
		  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="text-align: left;">
		  <span class="form-control-label" style="font-weight:bold">{{user_lang.change_forgot_pwd_qtn}}</span>
         <i class="fa fa-edit" style="cursor:pointer" @click = "secqsec = !secqsec"></i>
           <select v-model="selectedSecQN" style="width:100%;" v-show = "secqsec">
		    <optgroup v-bind:label="user_lang.stock_qtn">
            <option v-for="sq in listofsecquestions" v-bind:value="sq.question">{{sq.questionText}}</option>
			</optgroup>
			<optgroup v-bind:label="user_lang.custom_qtn">
            <option value="custom">{{user_lang.own_sec_qtn}}</option>
			</optgroup>
		   </select>
          </div>
      </div>
	  <div class="row" style="padding-top: 0px" v-show="selectedSecQN == 'custom' && secqsec">
		  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="text-align: left;">
		  <span class="form-control-label">{{user_lang.custom_qtn}}</span>
           <input v-model="custom_question" style="width:100%;"></input>
          </div>
      </div>
	  <div class="row" style="padding-top: 0px" v-show = "secqsec">
		  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="text-align: left;">
		  <span class="form-control-label">{{user_lang.answer}}</span>
           <input v-model="answer" placeholder="******" style="width:100%;"></input>
          </div>
		  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" style="text-align: left;">
		  <span style="color:transparent;width:100%;display: block;" class="sometext-hidden">sometext</span>
		  <button type="button" class="btn btn-primary adduser-btn" style="margin-left: 0px;max-height: 34px;" v-on:click="updateQA()" v-show="enableEdit"
		  v-bind:class = "{disabled : answer.length === 0}"> {{user_lang.update}}</button></div>
      </div>
	  </div-->
	  <span class="error" v-for="k in QAValidationObj" v-show = "enableEdit && secqsec">{{k}}</span>
	  <div style="margin-top: 10px;width: 100%;margin-right: 15px;cursor:pointer" v-show = "enableEdit">
        <button type="button" class="btn btn-primary adduser-btn" style="margin-left: 845px; max-height: 34px;" v-on:click="updateName()"> {{ user_lang.update }}</button>
			  <span v-on:click = "enableEdit = false, clearAllFieldsandValidations()" style="float: right;padding: 8px 20px;">{{user_lang.cancel}}</span>
		</div>
	  <!--div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
		  <div>
          <label for="message-text" class="form-control-label">{{user_lang.selectLang}}:</label>
          <span class="wrap-input">
		  <select v-model = "prefLang" class="preflang disabled" id="message-text">
          <option value="en_US" selected>English</option>
          <option value="pt_BR">Portuguese</option>
		<option value="es_ES">Vietnamese</option>
          </select>
 </span>
          </div>
	  </div-->
	  </div>
	  </div>
	  <div class="user-creds">
	  <div style="font-size:14px;font-weight:bold;">{{user_lang['assignedapps']}}</div>
	  <div class="row">
	  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding-top:5px;padding-right: 0px;">
	  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6 regapps" v-for="i in regApps"
	  @click = "goToApp(i.name.toLowerCase() === 'bookmark' ? i.settings.app.url : i._links.appLinks[0].href)"
	v-bind:title = "i.label">
	<div  class="icon-wrap">
	<img v-bind:src="i._links.logo[0].href" style="height: 34px;"/>
	</div>
	<div style="">{{i.label}}</div>
	</div>
	<!-- uncomment to show apps and groups list for user -->
	  <!--div class="form-wrap">
		  <div id="dropdown" class="">
		  <div v-show = "!regApps.length" style="padding-left: 5px;">...</div>
			<div v-for="i in regApps" style="padding-right: 15px;padding-left: 5px;display: block;font-weight:bold;" class="dd-list-item">
				<span style="">{{i.label}}</span>
		  <div v-show = "!selectedgroups.length" style="padding-left: 10px;">...</div>
				<div v-for="(j, index) in selectedgroups" v-show = "i.id === j.appId"
				style="font-weight:normal;padding-right: 15px;padding-left: 25px;display: block;border: 2px solid #eceff1;
				padding: 3px 10px;" class="dd-list-item" v-bind:class="{bb0 : index !== 0}">
				 {{j._embedded !== undefined ? j._embedded.group.profile.name : j.profile.name}}
			</div>
			</div>
		  </div>
	  </div-->
			</div>
	<!--div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding-top:5px;">
	  <div style="font-size:14px;font-weight:bold;">{{user_lang['assignedgroups']}}</div>
	  <div class="form-wrap">
		  <div id="dropdown" class="">
		  <div v-show = "!selectedgroups.length" style="padding-left: 5px;">...</div>
			<div v-for="i in selectedgroups" style="padding-right: 15px;padding-left: 5px;display: inline-block;" class="dd-list-item">
				{{i._embedded !== undefined ? i._embedded.group.profile.name : i.profile.name}}
			</div>
		  </div>
	  </div>
			</div -->
	</div>
				</div>
		  <!--div style="margin-top: 10px;" class="error-bg" id="formValidation" v-for = "i in addUserValidations">{{i}}</div>
		  <div style="height:40px;">
		  <button type="button" class="btn btn-primary create-btn" data-dismiss="modal" v-on:click="createUser">{{user_lang.inviteuser}}
          </button>
		  <span v-on:click="isShow = !isShow" class="cancel-btn">{{user_lang.cancel}}</span>
		  </div-->
        </div>
		</div>
	  </div>
    </div>  <!-- END: container -->
    </div>
</TopNavFooter>
</template>
<script>
  import TopNavFooter from "@/components/widgets/TopNavFooter"
  import UserTable from '../components/UserTable'
  import idmApi from '@/idm-api'
  import Spinner from '@/components/Spinner';
  import { locale } from '@/i18n/locale.js'
  import { EventBus } from '@/event-bus.js';
  import storage from '@/helpers/storage';
  const islowerCase = '^(?=.*[a-z])'
  const isUpperCase = '^(?=.*[A-Z])'
  const isNumber = '^(?=.*[0-9])'
  const isSpecialChar = '^(?=.*[!@#$%^&*-])'
  const isMinLength = '^(?=.{8,})'
  const apiUrl = process.env.API_URL;
  export default {
    name: 'admin',
    components: {
      TopNavFooter,
      UserTable,
      Spinner
    },
    created() {
      // this.changeCustomer();
      var self = this;
      self.updateAdminConfigsInLocal()
      self.userId = storage.get('cf-user').sub
      if (storage.get('idprovider') !== 'federation' || self.isServiceAccountGroupMember) {
        self.getPasswordPolicy()
      }
      self.checkPhoneNumber()
      self.getApps()
      this.user_lang = this.lang_br
      setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese
      EventBus.$on('lang', function (language) {
        self.user_lang = self.lang_obj[language]
        /* idmApi.getListOfSecurityQuestionsByLanguage(`${apiUrl}/auth/${language}/securityquestions`).then(function (response) {
          // console.log('List of security questions')
          self.listofsecquestions = response.data
        }) */
      })
      self.$root.$on('activatesuccess', function () {
        self.resetSuccess = true
      })
      $(document).on('keypress', 'input', function() {
        self.keyPressHandler()
      });
      $(window).on('beforeunload', function() {
        self.beforeUnloadHandler()
      });
      $(document).on('mousedown', '.donotedit', function(e) {
        e.preventDefault();
      });
      $(document).on('click', '#loggout, .nav-item a', function() {
        self.beforeLoggoutHandler()
      });
    },
    mounted () {
      var self = this
      self.listofsecquestions = storage.get('listofsecquestions')
      self.isServiceAccountGroupMember = storage.get('isServiceAccountGroupMember')
      self.isAzureUser = storage.get('idprovider') === 'federation' ? true : false // eslint-disable-line
      /* idmApi.getGroupsByUserId(`${apiUrl}/auth/users/${self.userId}/groups`).then(function (response) {
        self.isAzureUser = response.data.some(i => {
          return i.profile.name.trim().toLowerCase() === 'azuread'
        })
      })
      setTimeout(function() {
        idmApi.getListOfSecurityQuestionsByLanguage(`${apiUrl}/auth/${locale.lang}/securityquestions`).then(function (response) {
          // console.log('List of security questions')
          self.listofsecquestions = response.data
        })
      }, 1000) */
      $(document).ready(function() {
        $('[data-toggle="tooltip"]').tooltip();
      });
    },
    watch: {
      codeSent: function(newVal, oldVal) {
        this.watchcodeSent(newVal, oldVal)
      },
      phN: function() {
        this.watchphN()
      },
      passwordsec: function() {
        this.watchpasswordsec()
      },
      phnsec: function() {
        this.watchphnsec()
      },
      secqsec: function() {
        this.watchsecqsec()
      }
    },
    methods: {
      beforeLoggoutHandler() {
        var self = this
        if (self.codeSent) {
          self.enableEdit = false
        }
      },
      beforeUnloadHandler() {
        var self = this
        if (self.codeSent) {
          self.setBackOldActiveNumber()
        }
      },
      keyPressHandler() {
        var self = this
        self.formValidationObj = []
        self.phoneValidationObj = []
        self.QAValidationObj = []
        self.error30SecOTP = false
        self.phoneNumberNotValid = false
      },
      watchcodeSent(newVal, oldVal) {
        var self = this
        if (oldVal && !newVal) {
          self.setBackOldActiveNumber()
        }
      },
      watchphN() {
        var self = this
        if (self.countryCode === '1') {
          var x = self.phN.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
          self.phN = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        }
      },
      watchpasswordsec() {
        var self = this
        if (self.passwordsec) {
          self.phnsec = false
          self.secqsec = false
        }
      },
      watchphnsec() {
        var self = this
        if (self.phnsec) {
          self.passwordsec = false
          self.secqsec = false
        }
      },
      watchsecqsec() {
        var self = this
        if (self.secqsec) {
          self.passwordsec = false
          self.phnsec = false
        }
      },
      assignUserLang() {
        var self = this
        self.user_lang = self.lang_obj[this.lang]
      },
      /* eslint-disable */
      onf (e) {
        var self = this
        if (document.getElementById('pn').hasAttribute('readonly')) {
          console.log(self.isTriggered)
          document.getElementById('pn').removeAttribute('readonly');
          self.isTriggered = true
          document.getElementById('pn').blur()
          document.getElementById('pn').focus()
        }
      },
      onb (e) {
        var self = this
        if (self.isTriggered) {
          self.isTriggered = false;
          e.stopPropagation()
          console.log('triggered by code');
          return;
        } else {
          console.log('triggered by mouse');
          if (!document.getElementById('pn').hasAttribute('readonly')) {
            document.getElementById('pn').setAttribute('readonly', true);
          }
        }
      },
      /* eslint-disable */
      goToApp (url) {
        window.open(url, '_blank')
      },
      getPasswordPolicy () {
        var self = this
        self.loading = true
        idmApi.getPasswordPolicy(`${apiUrl}/auth/policies`).then(function (response) {
          self.passwordPolicyArray = response.data
          if (self.passwordPolicyArray.length === 1) {
            self.currPwdPolicy = response.data.filter(function(i) { if (i.name === 'Default Policy') return i })
          } else {
            self.currPwdPolicy = response.data.filter(function(i) { if (i.name === 'Legacy Policy') return i })
          }
          self.pwdComplexity = self.currPwdPolicy[0].settings.password.complexity
          self.minAnswerLength = self.currPwdPolicy[0].settings.recovery.factors.recovery_question.properties.complexity.minLength
          self.loading = false
        })
      },
      checkPhoneNumber () {
        var self = this
        self.loading = true
        idmApi.getFactorByUserId(`${apiUrl}/auth/users/${self.userId}/factors`).then(function (response) {
          self.loading = false
          var findSmsFactor = response.data.filter(x => x.factorType === 'sms')[0]
          if (findSmsFactor) {
            if (findSmsFactor.status.toLowerCase() === 'active') {
              self.activeNo = findSmsFactor.profile.phoneNumber
              // console.log(findSmsFactor.profile.phoneNumber)
            } else {
              self.activeNo = ''
            }
            self.phone = findSmsFactor.profile.phoneNumber
            if (findSmsFactor.status.toLowerCase().indexOf('pending') > -1) {
              self.factorStatus = self.user_lang.statuspending
              self.clearTopNotification()
              self.activationpending = true
            } else if (findSmsFactor.status.toLowerCase().indexOf('active') > -1) {
              self.factorStatus = self.user_lang.statusactive
            } else {
              self.factorStatus = findSmsFactor.status
            }
            self.smsFactorId = findSmsFactor.id
          }
        })
      },
      getSecurityQuestion: function() {
        var self = this;
        idmApi.getUserIdByEmail(`${apiUrl}/auth/users/${self.email}`).then(function (response) {
          if (response.data.profile.secondEmail) {
            self.addUserSecondaryEmail = response.data.profile.secondEmail;
          }
          if (response.data.credentials.recovery_question !== undefined) {            
            var secq = response.data.credentials.recovery_question.question
            var qKey = self.listofsecquestions && (self.listofsecquestions.filter(x => x.questionText === secq)[0]).question
            if (self.user_lang[qKey] !== undefined && qKey.indexOf('_') > -1) {
              self.selectedSecQN = qKey
            } else {
              self.selectedSecQN = 'custom'
              self.custom_question = response.data.credentials.recovery_question.question
            }
          }
        })
      },
      goBack () {
        this.codeSent = false;
        this.setBackOldActiveNumber()
        this.phoneValidationObj = []
      },
      reverseTransformEmail(em) {
        if (em.toLowerCase().indexOf('@identity.mycargill.com') > -1 || em.toLowerCase().indexOf('@whitelabel.cargill.com') > -1 || em.toLowerCase().indexOf('@partneridentity.okta-emea.com') > -1) {
          em = em.substring(5, em.indexOf('@')).substring(0, em.substr(0, 2) - 1) + '@' + em.substring(5, em.indexOf('@')).substring(em.substr(0, 2) - 1)
        }
        return em
      },
      getApps () {
        var self = this
        self.loading = true
        idmApi.getActiveAppNames(`${apiUrl}/auth/apps/${self.userId}`).then(function (response) {
          $('#userRegistration').css('display', 'block');
          var res = response.data.filter(y => y.name.toLowerCase() === 'oidc_client')
          self.firstname = res[0]._embedded.user.profile.name.split(' ')[0]
          self.lastname = res[0]._embedded.user.profile.name.split(' ')[1]
          self.email = res[0]._embedded.user.profile.login ? res[0]._embedded.user.profile.login : res[0]._embedded.user.profile.email
          storage.set('email', res[0]._embedded.user.profile.login ? res[0]._embedded.user.profile.login :res[0]._embedded.user.profile.email)
          self.reverseTransformedEmail = self.reverseTransformEmail(self.email)
          self.regApps = response.data.filter(function (item) {
            if (item.name.toLowerCase() !== 'oidc_client' && !item.visibility.hide.web) {
              return item
            }
          })
          self.getSecurityQuestion()
          self.adminAppsArray = []
          self.selectedgroups = []
          /* uncomment to show user groups under the apps */
          /* response.data.forEach(function(item) {
            if (item.name !== 'bookmark') {
              idmApi.getGroupsByAppId(`${apiUrl}/auth/apps/${item.id}/groups`).then(function (response) {
                for (var q = 0; q < response.data.length; q++) {
                  var obj = (response.data)[q]
                  var arr = response.config.url.split('/')
                  obj['appId'] = arr[arr.length - 2]
                  self.adminAppsArray.push(obj)
                  self.loading = true
                  idmApi.getGroupsByUserId(`${apiUrl}/auth/users/${self.userId}/groups`).then(function (response) {
                    for (var k = 0; k < response.data.length; k++) {
                      if (self.containsObject((response.data)[k], self.adminAppsArray) && !self.containsObject((response.data)[k], self.selectedgroups)) {
                        for (var y = 0; y < self.adminAppsArray.length; y++) {
                          if (self.adminAppsArray[y].id === ((response.data)[k]).id) {
                            var objG = (response.data)[k]
                            objG['appId'] = self.adminAppsArray[y].appId
                            self.selectedgroups.push(objG)
                          }
                        }
                      }
                    }
                    self.loading = false;
                  }).catch(err => {
                    self.loading = false;
                    console.log("create Insert CF Error: ", err);
                  });
                }
                self.loading = false;
              }).catch(err => {
                self.loading = false;
                console.log("create Insert CF Error: ", err);
              })
            }
          }) */
        }).catch(err => {
          self.loading = false;
          console.log("create Insert CF Error: ", err);
        })
      },
      editFields() {
        var self = this
        self.enableEdit = true
        self.checkPhoneNumber()
        self.clearAllFieldsandValidations()
      },
      clearAllFieldsandValidations() {
        this.oldpassword = ''
        this.password = ''
        this.repeatpassword = ''
        this.formValidationObj = []
        // this.pwdValidationObj = []
        // this.repeatPwdValidationObj = []
        this.phoneValidationObj = []
        this.QAValidationObj = []
        this.codeSent = false
        this.factorDeleted = false
        this.error30SecOTP = false
        this.phoneNumberNotValid = false
        this.passwordsec = false
        this.phnsec = false
        this.secqsec = false
        this.custom_question = ''
        this.answer = ''
        this.selectedSecQN = 'disliked_food'
      },
      validatePwdValues() {
        this.formValidationObj = []
        if (this.oldpassword.trim() === '' || this.password.trim() === '' || this.repeatpassword.trim() === '') {
          this.formValidationObj.push(this.user_lang.emptypassword)
          return false
        } else if (this.pwdValidationObj.length) {
          this.formValidationObj.push(this.user_lang.passwordnotvalid)
          return false
        } else if (this.repeatPwdValidationObj.length) {
          this.formValidationObj.push(this.user_lang.passwordnotmatching)
          return false
        } else {
          return true
        }
      },
      sendCode () {
        var self = this
        self.phoneValidationObj = []
        self.QAValidationObj = []
        if (self.countryCode === '' || self.countryCode === undefined) {
          self.phoneValidationObj.push('Please select country code')
          return
        }
        if (self.phN.replace(/\D/g, '').trim() === '' || !/^\d+$/.test(self.phN.replace(/\D/g, '').trim())) {
          self.phoneValidationObj.push('Please enter valid phone number')
          return
        }
        self.loading = true
        self.error30SecOTP = false
        self.phoneNumberNotValid = false
        self.iserror = false
        let data = {
          "factorType": "sms",
          "provider": "OKTA",
          "profile": {
            "phoneNumber": "+" + this.countryCode.replace(/^0+/, '') + this.phN.replace(/\D/g, '')
          }
        }
        idmApi.deleteSMSFactor(`${apiUrl}/auth/users/${self.userId}/factors/${self.smsFactorId}`).then(function (response) {
          idmApi.sendCode(`${apiUrl}/auth/users/${self.userId}/factors?updatePhone=true`, data)
            .then(function (response) {
              self.loading = false
              if (response.data.status.toLowerCase() === 'active') {
                self.iserror = false
              // self.issuccess = true
                self.clearTopNotification()
                self.smsFactorId = response.data.id
                self.errorCode = false
                self.codeSent = false
                self.factorDeleted = false
                self.phoneupdated = true
                self.enableEdit = false
                self.phone = response.data.profile.phoneNumber
              } else {
                self.codeSent = true
                self.verifycode = ''
                self.smsFactorId = response.data.id
              }
            }).catch(error => {
              console.log(error)
              self.loading = false
              if (error.response.status === 429) {
                self.error30SecOTP = true
              }
              if (error.response.status === 400) {
                // self.checkPhoneNumber()
                // self.phoneNoAlreadySet = true
                self.phoneNumberNotValid = true
              }
            })
        }).catch(error => {
          self.loading = false
          console.log(error.response.status + ' ' + error.response.data)
          if (error.response.status === 404) {
            self.handle404Error(data)
          }
        })
      },
      handle404Error(data) {
        idmApi.sendCode(`${apiUrl}/auth/users/${self.userId}/factors?updatePhone=true`, data)
          .then(function (response) {
            self.loading = false
            if (response.data.status.toLowerCase() === 'active') {
              self.iserror = false
              // self.issuccess = true
              self.clearTopNotification()
              self.smsFactorId = response.data.id
              self.errorCode = false
              self.codeSent = false
              self.factorDeleted = false
              self.phoneupdated = true
              self.enableEdit = false
              self.phone = response.data.profile.phoneNumber
            } else {
              self.codeSent = true
              self.verifycode = ''
              self.smsFactorId = response.data.id
            }
          }).catch(error => {
            console.log(error)
            self.loading = false
            if (error.response.status === 429) {
              self.error30SecOTP = true
            }
            if (error.response.status === 400) {
              // self.checkPhoneNumber()
              // self.phoneNoAlreadySet = true
              self.phoneNumberNotValid = true
            }
          })
      },
      updatePhone() {
        var self = this
        self.factorDeleted = true
      },
      updatePwd() {
        var self = this
        if (self.validatePwdValues()) {
          var data = {"oldPassword": { "value": self.oldpassword }, "newPassword": { "value": self.password }}
          idmApi.changePassword(`${apiUrl}/auth/users/${self.userId}/changepassword`, data).then(function (response) {
            self.clearTopNotification()
            self.pwdupdated = true
            self.enableEdit = false
          }).catch(error => {
            console.log(error)
            self.phoneValidationObj = []
            self.QAValidationObj = []
            self.formValidationObj.push(error.response.data.errorCauses[0].errorSummary)
          });
        }
      },
      validateSpecialCharacters: function(text) {
        let re = /^[\w-_.]*$/;
        return re.test(text);
      },
      validEmail: function(email) {
        var re = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
        return re.test(email);
      },
      updateName() {
        let self = this;
        let validate = true;
        if (self.firstname.trim() === '') {
          validate = false;
        } else if (!this.validateSpecialCharacters(self.firstname.trim())) {
          validate = false;
        } else if (self.lastname.trim() === '') {
          validate = false;
        } else if (!this.validateSpecialCharacters(self.lastname.trim())) {
          validate = false;
        }  else if (this.addUserSecondaryEmail.trim() !== '' && !this.validEmail(this.addUserSecondaryEmail)) {
          validate = false;
        }
        if (!validate) {
          return;
        }
        let data = {"profile": { "firstName": self.firstname, lastName: self.lastname, secondEmail: self.addUserSecondaryEmail }};
        idmApi.updateName(`${apiUrl}/auth/users/updateUser?userId=${self.userId}`, data).then(function (response) {
          self.clearTopNotification()
          self.nameUeUpdated = true;
          self.enableEdit = false;
        }).catch(error => {
          console.log(error)
          self.formValidationObj.push(error.response.data.errorSummary)
        });
      },
      verifySMS () {
        var self = this
        let data = { "passCode": self.verifycode }
        idmApi.verifyPasscodeOnFactorSetting(`${apiUrl}/auth/users/${self.userId}/factors/${self.smsFactorId}/activate`, data).then(function (response) {
          // self.activateFactorId = response.data.id
          if (response.data.status === 'ACTIVE') {
            self.smsFactorId = response.data.id
            self.clearTopNotification()
            self.errorCode = false
            self.codeSent = false
            self.factorDeleted = false
            self.phoneupdated = true
            self.enableEdit = false
            self.activeNo = response.data.profile.phoneNumber
            self.phone = response.data.profile.phoneNumber
          } else {
            // self.codeSent = false;
            self.loading = false
          }
        }).catch(error => {
          self.verifyPasscodeErrorHandler(error)
        })
      },
      verifyPasscodeErrorHandler(error) {        
        console.log(error)
        var self = this
        self.iserror = true
        // self.pwdValidationObj = []
        // self.repeatPwdValidationObj = []
        self.phoneValidationObj = []
        self.QAValidationObj = []
        self.phoneValidationObj.push(error.response.data.errorCauses[0].errorSummary)
        // self.codeSent = false;
        this.loading = false
	  },
      containsObject(obj, list) {
        var i;
        for (i = 0; i < list.length; i++) {
          if (list[i].id === obj.id) {
            return true;
          }
        }
        return false;
      },
      updateQA () {
        var self = this
        self.loading = true
        if (self.validateQA()) {
          let data = {
            "credentials": {
              "recovery_question": {
                "question": self.selectedSecQN === 'custom' ? self.custom_question : (this.listofsecquestions.filter(x => x.question === self.selectedSecQN)[0]).questionText,
                "answer": self.answer
              }
            }
          }
          idmApi.setUserAccount(`${apiUrl}/auth/users/${self.userId}`, data).then(function (response) {
            self.loading = false
            self.clearTopNotification()
            self.QAupdated = true
            self.enableEdit = false
            $('html, body').animate({ scrollTop: 0 }, 'fast');
          }).catch(error => {
            console.log(error)
            if (error.response.data.errorCauses !== undefined && error.response.data.errorCauses.length > 0) {
              self.QAValidationObj.push(error.response.data.errorCauses[0].errorSummary)
            }
            self.loading = false
          })
        } else {
          self.loading = false;
        }
      },
      validateQA () {
        this.QAValidationObj = []
        if (this.selectedSecQN === undefined || this.selectedSecQN === null || this.selectedSecQN === '') {
          this.QAValidationObj.push(this.user_lang.choose_forgot_pwd_qtn)
          return false
        } else if (this.selectedSecQN === 'custom' && this.custom_question.trim() === '') {
          this.QAValidationObj.push(this.user_lang.customQuestionEmpty)
          return false
        } else if (this.selectedSecQN === 'custom' && this.custom_question.trim() === this.answer.trim()) {
          this.QAValidationObj.push(this.user_lang.customQAsame)
          return false
        } else if (this.answer.trim().length < this.minAnswerLength) {
          this.QAValidationObj.push(this.user_lang.answerlength.replace('$', this.minAnswerLength))
          return false
        } else if (this.selectedSecQN === 'custom' && this.custom_question.trim().indexOf(this.answer.trim()) > -1) {
          this.QAValidationObj.push(this.user_lang.answerpartofquestion)
          return false
        // } else if (this.selectedSecQN === 'custom') {
        //   var questionWordsArray = this.custom_question.trim().toLowerCase().split(' ')
        //   var answerWordsArray = this.answer.trim().toLowerCase().split(' ')
        //   var isWeak = questionWordsArray.some(r => answerWordsArray.indexOf(r) >= 0 && r.trim() !== '')
        //   if (isWeak) {
        //     this.QAValidationObj.push(this.user_lang.securityquestionanswerweak)
        //     return false
        //   } else {
        //     this.QAValidationObj = []
        //     return true
        //   }
        } else {
          var question = this.selectedSecQN === 'custom' ? this.custom_question.trim().toLowerCase() : this.listofsecquestions.filter(x => x.question === this.selectedSecQN)[0].questionText
          question = question.replace('?', '')
          console.log(question)
          var questionWordsArray = question.trim().toLowerCase().split(' ')
          console.log(questionWordsArray)
          var answerWordsArray = this.answer.trim().toLowerCase().split(' ')
          console.log(answerWordsArray)
          var isWeak = questionWordsArray.some(r => answerWordsArray.indexOf(r) >= 0 && r.trim() !== '')
          if (isWeak) {
            var term = questionWordsArray.filter(r => answerWordsArray.indexOf(r) >= 0 && r.trim() !== '')
            console.log(term)
            this.user_lang.securityanswermatchesquestion = this.user_lang.copysecurityanswermatchesquestion.replace('$', "\"" + term + "\"")
            this.QAValidationObj.push(this.user_lang.securityanswermatchesquestion)
            return false
          } else {
            this.QAValidationObj = []
            return true
          }
        }
      },
      setBackOldActiveNumber() {
        // console.log('setBackOldActiveNumber')
        if (this.activeNo === '') {
          return
        }
        var self = this
        let data = {
          "factorType": "sms",
          "provider": "OKTA",
          "profile": {
            "phoneNumber": this.activeNo
          }
        }
        self.loading = true
        idmApi.sendCode(`${apiUrl}/users/${self.userId}/factors?activate=true`, data).then(function (response) {
          self.smsFactorId = response.data.id
          self.loading = false
        }).catch(error => {
          console.log(error)
          self.loading = false
        })
      },
      clearTopNotification() {
        var self = this
        self.phoneupdated = false
        self.pwdupdated = false
        self.QAupdated = false
        self.activationpending = false
      },
      updateAdminConfigsInLocal() {
        var adminGroupsArr = []
        var adminAppsArr = []
        idmApi.getListOfAdminConfig(`${apiUrl}/auth/appGroupList`).then(function (response) {
          adminGroupsArr = response.data.map(function(i) {
            return i.groupId
          })
          adminAppsArr = response.data.map(function(i) {
            return i.applicationId
          })
          storage.set('adminConfigMaster', JSON.stringify(response.data))
          storage.set('adminConfigJSON', JSON.stringify(adminGroupsArr))
          storage.set('adminConfigJSONApps', JSON.stringify(adminAppsArr))
        }).catch(err => {
          console.log(err)
        })
      }
    },
    data() {
      return {
        listofsecquestions: [],
        lang: locale.lang,
        lang_obj: locale.lang_obj,
        addUserClicked: false,
        deactivateForm: false,
        row: {},
        userId: '',
        userrole: '',
        searchUser: '',
        oktauserId: '',
        email: '',
        reverseTransformedEmail: '',
        addUserSecondaryEmail: '',
        customers: {},
        passwordPolicyArray: [],
        formValidationObj: [],
        phoneValidationObj: [],
        QAValidationObj: [],
        currPwdPolicy: {},
        pwdComplexity: {},
        pwdErrorArray: [],
        loading: false,
        user_lang: {},
        firstname: '',
        lastname: '',
        prefLang: 'en_US',
        adminItem: {
          name: 'Admin',
          displayName: "Administração",
          to: '/Admin'
        },
        listToMultiselect: [],
        selectedgroups: [],
        enableEdit: false,
        regApps: [],
        oldpassword: '',
        password: '',
        repeatpassword: '',
        phone: '',
        pwdupdated: false,
        QAupdated: false,
        nameUpdated: false,
        smsFactorId: '',
        error30SecOTP: false,
        phoneNumberNotValid: false,
        codeSent: false,
        emptypasscode: false,
        passCodeInvalid: false,
        verifycode: '',
        factorDeleted: false,
        countryCode: '',
        phN: '',
        phoneupdated: false,
        adminAppsArray: [],
        factorStatus: '',
        selectedSecQN: '',
        custom_question: '',
        answer: '',
        minAnswerLength: '',
        activeNo: '',
        activationpending: false,
        isTriggered: false,
        passwordsec: false,
        phnsec: false,
        secqsec: false,
        isAzureUser: false,
        isServiceAccountGroupMember: false
      }
    },
    computed: {
      // var regexStr = '^'+isNumber+isMinLength
      // var pwdRegex = new RegExp(regexStr)
      pwdValidationObj: function() {
        var errors = []
        var minCharRegex = isMinLength.replace('8', this.pwdComplexity.minLength)
        // console.log(this.password)
        if (this.password.trim().length > 0) {
          if (this.pwdComplexity.minLowerCase > 0 && !this.password.trim().match(new RegExp(islowerCase))) {
            errors.push(this.user_lang.noLowerCase)
          }
          if (this.pwdComplexity.minUpperCase > 0 && !this.password.trim().match(new RegExp(isUpperCase))) {
            errors.push(this.user_lang.noUpperCase)
          }
          if (this.pwdComplexity.minNumber > 0 && !this.password.trim().match(new RegExp(isNumber))) {
            errors.push(this.user_lang.noNumber)
          }
          if (this.pwdComplexity.minSymbol > 0 && !this.password.trim().match(new RegExp(isSpecialChar))) {
            errors.push(this.user_lang.noSpecialCharacter)
          }
          if (!this.password.trim().match(new RegExp(minCharRegex))) {
            errors.push(this.user_lang.notMinLength.replace('$', this.pwdComplexity.minLength))
          }
          if (this.pwdComplexity.excludeAttributes !== undefined && this.pwdComplexity.excludeAttributes.includes('lastName') &&
          this.password.trim().indexOf(this.lastName) !== -1) {
            errors.push(this.user_lang.noLastnameSubstring)
          }
          if (this.pwdComplexity.excludeAttributes !== undefined && this.pwdComplexity.excludeAttributes.includes('firstName') &&
          this.password.trim().indexOf(this.firstName) !== -1) {
            errors.push(this.user_lang.noFirstnameSubstring)
          }
          if (this.pwdComplexity.excludeUsername && this.email.indexOf(this.password.trim()) > -1) {
            errors.push(this.user_lang.noUsernameSubstring)
          }
          if (errors.length === 0) {
            this.pwdValid = true
          }
        }
        this.pwdErrorArray = errors
        return errors
      },
      repeatPwdValidationObj: function() {
        var errors = []
        if (this.repeatpassword.trim().length > 0) {
          if (this.password.trim() !== this.repeatpassword.trim()) {
            errors.push(this.user_lang.passwordnotmatching)
          }
        }
        this.pwdErrorArray = errors
        return errors
      }
    }
  }
</script>
<style scoped>
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
    padding: 0;
  }
.custom-select {
	display: inline-block;
	max-width: 100%;
	height: calc(2.50rem + 2px);
	padding: 0.375rem 1.75rem 0.375rem 0.75rem;
	line-height: 1.25;
	background-color: #ececeb;
	vertical-align: middle;
	background-size: 8px 10px;
	border: 1px solid #00524A;
	border-radius: 0;
	-moz-appearance: none;
	-webkit-appearance: none;
}
.card-block {
	background: #eceff1;
}
.user-input {
	width: 100%;
	background: #ffffff;
	color: #333333;
	height: 30px;
}
.user-select {
	color: #333333;
	height: 30px;
}
#userSearch {
	margin: 10px;
}
.good-table th {
	color: #333333 !important
}
.btn-secondary:active {
	background: #007299;
	box-shadow: none;
}
.btn-secondary {
	background: var(--theme-primary);
	color: #ffffff;
}
input {
	width: 130px;
	box-sizing: border-box;
	border: 1px solid var(--theme-primary);
	border-radius: 0;
	font-size: 16px;
	background-color: #f1f1f1;
	background-position: 10px 10px;
	background-repeat: no-repeat;
	padding: 15px 20px;
	height: 50px;
}
.card {
	position: relative;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	background-color: #33373D;
	border: 0px solid rgba(0, 0, 0, 0.125);
	border-radius: 0px;
	box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px
		rgba(0, 0, 0, 0.22);
	box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.4);
}
.card {
	margin-bottom: 1rem;
	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}
.card-block1 {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 0rem;
}
#searchId {
	box-sizing: border-box !important;
	border: 2px solid #dde3e6 !important;
	border-radius: 0 !important;
	background-color: #fff !important;
	background-position: 10px 10px !important;
	background-repeat: no-repeat !important;
	height: 40px !important;
	margin-bottom: 18px !important;
	margin-left: 30px !important;
}
.filter-label{ width: 150px;
    float: left;
    font-size: 14px;
    margin-top: 8px;
    font-weight: bold;
}
.btn-secondary {
	background-color: var(--theme-primary);;
	border-color: #00433c;
}
.btn-secondary:hover {
	background-color: #00524A;
	border-color: #00433c;
}
.btn {
	padding: 14px 24px;
	border: 0 none;
	font-weight: 700;
	letter-spacing: 1px;
	text-transform: uppercase;
}
/* Pills styles */
.nav-pills .nav-link.active, .nav-pills .nav-item.show .nav-link {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #FFF;
    background-color:#fff;
    color: var(--theme-primary);
    width: 15rem;
}
.nav-pills .nav-link {
    padding: 15px 30px;
    border-top: 1px solid var(--theme-primary);
    border-right: 1px solid var(--theme-primary);
    border-left: 1px solid var(--theme-primary);
    border-bottom: 1px solid var(--theme-primary);
    border-radius: 0rem;
    background-color:var(--theme-primary);
    color:#fff;
    width: 15rem;
}
.nav-pills .nav-link:hover {
    padding: 15px 30px;
    border-top: 1px solid #00524A;
    border-right: 1px solid #00524A;
    border-left: 1px solid #00524A;
    border-bottom: 1px solid var(--theme-primary);
    background-color:#00524A;
    color:#fff;
    width: ;
}
.nav-pills .nav-link.active:hover {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #FFF;
    background-color:#FFF;
    color: var(--theme-primary);
    width: ;
}
.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    background-color:#00524A;
    color: #fff;
}
.nav-tabs .nav-link {
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}
.nav-link:focus, .nav-link:hover {
    text-decoration: none;
}
/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575px) {
.nav-pills, .nav-link {
  width: 100%;
}
.nav-item {
  margin: 5px 0 0 0;
}
.nav-pills .nav-link.active, .nav-pills .nav-item.show .nav-link {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #CECECB;
    margin: 2px 0;
    background-color:#fff;
    color: var(--theme-primary);
    width: 100%;
}
.nav-pills .nav-link {
    padding: 15px 30px;
    border-top: 1px solid var(--theme-primary);
    border-right: 1px solid var(--theme-primary);
    border-left: 1px solid var(--theme-primary);
    border-bottom: 1px solid var(--theme-primary);
    margin: 2px 0;
    border-radius: 0rem;
    background-color:var(--theme-primary);
    color:#fff;
    width: 100%;
}
.barchart {
  display:none;
}
}
/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
  .nav-pills, .nav-link {
  width: 100%;
}
  .nav-item {
    margin: 0 0 0 1px;
}
.nav-link {
    margin: 0;
}
.nav-pills .nav-link.active, .nav-pills .nav-item.show .nav-link {
    padding: 15px 30px;
    border-top: 1px solid #CECECB;
    border-right: 1px solid #CECECB;
    border-left: 1px solid #CECECB;
    border-bottom: 1px solid #CECECB;
    margin: 2px 0;
    background-color:#fff;
    color: var(--theme-primary);
    width: 100%;
}
.nav-pills .nav-link {
    padding: 15px 30px;
    border-top: 1px solid var(--theme-primary);
    border-right: 1px solid var(--theme-primary);
    border-left: 1px solid var(--theme-primary);
    border-bottom: 1px solid var(--theme-primary);
    margin: 2px 0;
    border-radius: 0rem;
    background-color:var(--theme-primary);
    color:#fff;
    width: 100%;
}
.barchart {
  display:none;
}
}
.input-adduser{
    height: initial;
    padding: 5px 15px;
    width: 100%;
	background: #fff;
	margin: 0px !important
}
.input-checkbx{
width: 20px;
height: 20px;
display: inline-block;
}
.preflang{
    width: 100%;
    min-height: 34px;
	}
.success-bg{
    background: #90ee90;
}
.error-bg{
   background: #ffc0cb;
}
.form-control-label{min-width: 120px;font-size:12px;}
.wrap-input{display:block;overflow:hidden}
.form-wrap{    margin-bottom: 3px;}
.create-btn{margin-top: 10px;
    height: 40px;
    line-height: 0px;font-size: 12px;float:right;}
.search-icon{margin-top: 10px;
    margin-top: 0px;
    height: 40px !important;
    line-height: 0px;
    padding: 12px 24px 14px 24px;
	margin-bottom: 10px;
    border-radius: 0px;}
.tableContainer{padding: 0px 15px 30px;    overflow-x: auto;}
.input-group{
    width: 100%;
    background: #fff;
    margin: 0px -15px 0p;
    padding: 5px;
    outline: 15px solid #fff;
    /* margin: 0px -15px; */
}
.input-group-btn {max-width:65px}
.sub-group{display: inline-block}
@media (max-width: 1050px) {
  .input-group {
    width:100% !important;
	display: block;
  }
}
@media (max-width: 768px) {
  .sub-group {
    width:100% !important;
	display: block;
  }
  .searchId{max-width: 230px;}
  .filter-text{margin-left: 0px !important}
  .adduser-btn{margin-left: 0px !important}
}
.dropdown div, .dropdown dt {
    margin:0px;
    padding:0px;
}
.dropdown ul {
    margin:0px;
    padding:0px;
}
.dropdown div {
    position:relative;
    margin:0px;
    padding:0px;
}
.dropdown a, .dropdown a:visited {
    color:#fff;
    text-decoration:none;
    outline:none;
    margin:0px;
    padding:0px;
    min-height: 30px;
    border-radius: 3px;
}
.dropdown div a {
    background-color:#4F6877;
    display:block;
    overflow: hidden;
    width:100%;
    margin:0px;
    padding:0px;
}
.dropdown div a span, .multiSel span {
    cursor:pointer;
    display:inline-block;
    margin:0px;
    padding:5px 10px;
}
.dropdown div ul {
    background-color: #4F6877;
    top:1px;
    color:#fff;
    display:none;
    position:absolute;
    width:100%;
    list-style:none;
    height: 100px;
    overflow: auto;
    margin:0px;
    padding:0px;
}
.dropdown span.value {
    display:none;
    border-radius: 3px;
    margin:0px;
    padding:0px;
}
.dropdown div ul li a {
    display:block;
    margin:0px;
    padding:0px;
}
.dropdown div ul li a:hover {
    background-color:#fff;
    margin:0px;
    padding:0px;
}
.selectDropDown{border: 2px solid #dde3e6;height:34px;
    /* border-radius: 3px; */
    cursor: pointer;
    background: #fff;
	width: 100%;}
#checkboxlist{position: relative;
    margin-top: 0px;
	background:#fff;
	border: 1px solid #ccc;
	min-width: 200px;}
.dd-list-item:hover{background:#fff}
button {background:var(--theme-primary) !important}
.adduser-btn{margin-left: 20px;max-height: 40px;margin-top: 0px;line-height: 0px;height: 40px;background-color: var(--theme-primary);font-size: 12px;}
input, select{
background: #fff!important;
    border: 2px solid #dde3e6!important;
	padding-left: 10px !important;
    font-size: 14px !important;}
.bc{font-size:10px;font-weight:bold;}
.bc-adduser{font-size:10px;font-weight:bold;margin:15px}
.bc-nav:hover{text-decoration:underline; cursor:pointer}
.user-creds{background:#fff;    padding: 5px 10px 10px;
    margin-bottom: 12px;}
.bb0{border-top:0px !important}
.add-group{color:var(--theme-primary);font-size:18px;float:right;margin-top: 5px;cursor:pointer}
.remove-group{color:#d80842;font-size:18px;float:right;margin-top: 5px;cursor:pointer}
.group-div{border:2px solid #eceff1;padding: 3px 10px;}
.group-name{display: inline-block;width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;}
.usercreateinfo{margin-top: 10px;background: #546e7a;color: #fff;padding: 10px;margin-bottom: 10px;}
@media screen and (max-width: 767px) {
.main-content{padding-top:25px}
.main-content{padding-left:0px}
}
@media screen and (min-width: 768px) {
.main-content{padding-top:0px}
.main-content{padding-left:200px}
}
@media screen and (min-width: 991px) {
.search-bar-wrapper{width: 100%}
.search-bar-select{width: 300px;}
}
@media screen and (max-width: 991px) {
.search-bar-wrapper{width: 75%}
.search-bar-select{width: 150px;}
}
.cancel-btn{    float: right;
    display: block;
    padding: 18px 30px;}
input, select { height: 34px !important; color: #000 !important}
button { height: 32px !important; color: #fff !important}
.disabled {pointer-events:none;opacity:0.5;
-webkit-user-select: none;  /* Chrome all / Safari all */
  -moz-user-select: none;     /* Firefox all */
  -ms-user-select: none;      /* IE 10+ */
  user-select: none;          /* Likely future */
  }
.error{    color: red;width: 100%;
    margin-left: 15px;}
.pwderror{max-width:initial;width:100%;font-size: 14px;}
.codeVerifybtn{background:#f9f9f9;
color:#595959;
border:1px solid #c3c3c3;
font-size:13px;
display: inline-block !important;
 margin-top: -2px;
 height: 30px;
 line-height: 14px;
 width: 87px;}
.fa-check-circle {font-size:40px !important}
label{margin-bottom:0px !important;}
user-creds label{font-weight: normal !important;}
.sometext-hidden{
-webkit-user-select: none; /* Chrome/Safari */
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* IE10+ */
}
input::-webkit-contacts-auto-fill-button {
  display: none !important;
  position: absolute;
  right: 0;
}
.regapps{
max-width: 200px;
width:150px;
padding: 5px;
margin: 15px;
cursor: pointer;
text-align: center;
display: inline-block;
vertical-align: top;
}
.fa-edit{color:#546E7A;font-size: 18px;
    vertical-align: middle;}
.edit-pen{width: 20px;
    margin-top: -5px;
	image-rendering: -moz-crisp-edges;         /* Firefox */
image-rendering:   -o-crisp-edges;         /* Opera */
image-rendering: -webkit-optimize-contrast;/* Webkit (non-standard naming) */
image-rendering: crisp-edges;
-ms-interpolation-mode: nearest-neighbor;  /* IE (non-standard property) */}
@media all and (-ms-high-contrast:none)
 {
 *::-ms-backdrop, input { padding: 5px 10px !important } /* IE11 */
 }
</style>



// WEBPACK FOOTER //
// MyProfile.vue?1796ba14